const matchConfigPresets = [
    {
        title: 'Floorball / Innebandy (Effective 3x20min + 1x5min OT)',
        relatedSports: ['floorball'],
        config: {
            regularPeriods: { quantity: 3, duration: 20 * 60, allowExtraTime: false },
            overtimePeriods: { quantity: 1, duration: 5 * 60, allowExtraTime: false },
            penalties: {
                requiresPlayerJerseyNumber: false,
                durations: [
                    // 2 min
                    { value: 2 * 60 },
                    // 2+2 min
                    { value: 4 * 60, text: '2+2min' },
                    // 5 min
                    { value: 5 * 60 },
                    // 2 min + 10 min personal penalty
                    { value: 2 * 60, text: '2+10min' },
                ],
            },
        },
    },
    {
        title: 'Floorball / Innebandy (Effective 3x20min + 1x10min OT)',
        relatedSports: ['floorball'],
        config: {
            regularPeriods: { quantity: 3, duration: 20 * 60, allowExtraTime: false },
            overtimePeriods: { quantity: 1, duration: 10 * 60, allowExtraTime: false },
            penalties: {
                requiresPlayerJerseyNumber: false,
                durations: [
                    // 2 min
                    { value: 2 * 60 },
                    // 2+2 min
                    { value: 4 * 60, text: '2+2min' },
                    // 5 min
                    { value: 5 * 60 },
                    // 2 min + 10 min personal penalty
                    { value: 2 * 60, text: '2+10min' },
                ],
            },
        },
    },
    // Handball
    {
        title: 'Handball (Effective 2x30min + 2x10min OT)',
        relatedSports: ['handball'],
        config: {
            regularPeriods: { quantity: 2, duration: 30 * 60, allowExtraTime: false },
            overtimePeriods: { quantity: 1, duration: 10 * 60, allowExtraTime: false },
            penalties: {
                requiresPlayerJerseyNumber: false,
                durations: [
                    // 2 min
                    { value: 2 * 60 },
                    // 2+2 min
                    { value: 4 * 60, text: '2+2min' },
                ],
            },
        },
    },
    // Soccer
    {
        title: 'Soccer (2x45min + 2x15min OT)',
        relatedSports: ['soccer'],
        config: {
            regularPeriods: { quantity: 3, duration: 45 * 60, allowExtraTime: true },
            overtimePeriods: { quantity: 2, duration: 15 * 60, allowExtraTime: true },
            penalties: null,
        },
    },
    // Bandy
    {
        title: 'Bandy (2x45min + 10min OT)',
        relatedSports: ['bandy'],
        config: {
            regularPeriods: { quantity: 2, duration: 45 * 60, allowExtraTime: true },
            overtimePeriods: { quantity: 1, duration: 15 * 60, allowExtraTime: true },
            penalties: null,
        },
    },
];
export default matchConfigPresets;
//# sourceMappingURL=match-config-presets.js.map